import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { CardComponent } from '../../../core/panels/card.component';
import { ChartConfig } from '../../../core/chart/chart.component';
import { SidekickChartComponent } from './sidekick-chart.component';
import { BaseComponent } from '../../../base/base.component';

@Component({
  selector: 'app-au-summary',
  imports: [
    CommonModule,
    DetailPanelComponent,
    DetailItemComponent,
    CardComponent,
    SidekickChartComponent,
  ],
  template: ` <div class="tw-flex tw-gap-4">
    <div [class]="showFinancials ? 'tw-basis-2/3' : 'tw-basis-full'">
      <div class="tw-flex tw-gap-8 tw-pb-8">
        <div class="tw-basis-full">
          <app-detail-panel [dataSource]="dataSource">
            <app-detail-item
              label="Type of injury/damages"
              name="typeOfInjury"
              labelPosition="Top"
              labelCase="none"
            />
            <app-detail-item
              label="Liability assessment"
              name="liabilityAssessment"
              labelPosition="Top"
            />
            <app-detail-item
              label="Claim status"
              name="claimStatus"
              labelPosition="Top"
            />
            <app-detail-item
              label="Summary of actions"
              name="summaryOfActions"
              labelPosition="Top"
            />
            <app-detail-item
              label="Legal aspects"
              name="legalAspects"
              labelPosition="Top"
            />
            <app-detail-item
              label="Path to resolution"
              name="pathToResolution"
              labelPosition="Top"
            />
          </app-detail-panel>
        </div>
      </div>
      <div class="tw-flex tw-gap-8 tw-pb-8">
        <div class="tw-basis-full">
          <app-card label="Claim Details">
            <div class="tw-flex tw-gap-8 tw-pb-4">
              <div class="tw-basis-1/2">
                <app-detail-panel [dataSource]="dataSource">
                  <app-detail-item label="Involved Party" name="claimant" />
                  @if (showClaimantDateOfBirth) {
                    <app-detail-item
                      label="Claimant date of birth"
                      name="claimantDateOfBirth"
                      format="d"
                    />
                  }
                  @if (showCurrentAge) {
                    <app-detail-item label="Current Age" name="currentAge" />
                  }
                  <app-detail-item
                    label="Client Location"
                    name="clientLocation"
                  />
                  <app-detail-item label="Client Name" name="clientName" />
                  @if (showAccountName) {
                    <app-detail-item label="Account Name" name="accountName" />
                  }
                  <app-detail-item
                    label="Insured Driver Name"
                    name="insuredDriverName"
                  />
                  <app-detail-item
                    label="Insured Vehicle Involved"
                    name="insuredVehicleInvolved"
                  />
                  <app-detail-item label="VIN" name="vin" labelCase="upper" />
                  <app-detail-item label="Policy Number" name="policyNumber" />
                  <app-detail-item label="Loss Location" name="lossLocation" />
                </app-detail-panel>
              </div>
              <div class="tw-basis-1/2">
                <app-detail-panel [dataSource]="dataSource">
                  <app-detail-item
                    label="Date Prepared"
                    name="datePrepared"
                    format="d"
                  />
                  <app-detail-item
                    label="Date Of Loss"
                    name="dateOfLoss"
                    format="d"
                  />
                  <app-detail-item
                    label="Claims Examiner"
                    name="claimsExaminer"
                  />
                  <app-detail-item label="Claim Number" name="claimNumber" />
                  @if (showDateClaimReported) {
                    <app-detail-item
                      label="Date Claim Reported"
                      name="dateClaimReported"
                      format="d"
                    />
                  }
                  <app-detail-item label="Claim Type" name="claimType" />
                  @if (showCauseOfLoss) {
                    <app-detail-item label="Cause Of Loss" name="causeOfLoss" />
                  }
                  @if (showNatureOfLoss) {
                    <app-detail-item
                      label="Nature Of Loss"
                      name="natureOfLoss"
                    />
                  }
                  @if (showPartTarget) {
                    <app-detail-item
                      label="Part/target"
                      name="partTarget"
                      labelCase="none"
                    />
                  }
                  <app-detail-item label="Status" name="status" />
                  @if (showDateClosed) {
                    <app-detail-item
                      label="Date Of Claim Closure"
                      name="dateClosed"
                      format="d"
                    />
                  }
                </app-detail-panel>
              </div>
            </div>
            <div>
              <hr />
            </div>
            <div class="tw-flex tw-gap-8 tw-pt-4">
              <div class="tw-basis-1/2">
                <app-detail-panel [dataSource]="dataSource">
                  <app-detail-item label="Subrogation" name="subrogation" />
                  <app-detail-item label="Litigation" name="litigation" />
                  <app-detail-item
                    label="Claimant's Attorney"
                    name="claimantsAttorney"
                  />
                  <app-detail-item
                    label="Punitive Damages"
                    name="punitiveDamages"
                  />
                </app-detail-panel>
              </div>
              <div class="tw-basis-1/2">
                <app-detail-panel [dataSource]="dataSource">
                  <app-detail-item label="Excess" name="excess" />
                  <app-detail-item label="Court" name="court" />
                  <app-detail-item
                    label="Defense Attorney"
                    name="defenseAttorney"
                  />
                  <app-detail-item label="Tendered" name="tendered" />
                </app-detail-panel>
              </div>
            </div>
          </app-card>
        </div>
      </div>
    </div>
    @if (showFinancials) {
      <div class="tw-basis-1/3">
        <div class="tw-flex tw-pl-8 tw-flex-col tw-pb-4">
          <app-sidekick-chart [dataSource]="indemnityDataSource" title="Loss" />
          <app-sidekick-chart
            [dataSource]="expenseDataSource"
            title="Expense"
          />
          <app-sidekick-chart [dataSource]="totalsDataSource" />
        </div>
      </div>
    }
  </div>`,
  styles: [],
})
export class AuSummaryComponent extends BaseComponent implements OnInit {
  @ViewChildren(SidekickChartComponent) private chartComponents!: QueryList<SidekickChartComponent>;

  @Input() dataSource: any;

  showCurrentAge = true;
  showClaimantDateOfBirth = true;
  showAccountName = true;
  showDateClaimReported = true;
  showDateClosed = true;
  showCauseOfLoss = true;
  showNatureOfLoss = true;
  showPartTarget = true;
  showFinancials = true;

  expenseDataSource: any = {
    firstPartyDeductible: 5000,
    totalIncurred: 100000,
    configData: new ChartConfig(),
  };
  totalsDataSource: any = {
    firstPartyDeductible: 5000,
    totalIncurred: 100000,
    configData: new ChartConfig(),
  };

  indemnityDataSource: any = {
    firstPartyDeductible: 5000,
    totalIncurred: 100000,
    configData: new ChartConfig(),
  };

  ngOnInit(): void {
    const paidColor = '#3b3cc2';
    const reserveColor = '#08857d';

    this.initFieldSecurity();
    this.showFinancials = this.session.authorize('ClaimSummaryIncurred');
    if (this.dataSource?.financials) {
      const financials = this.dataSource.financials;

      this.indemnityDataSource = {
        firstPartyDeductible: financials.indemnityDeductible || 0,
        totalIncurred: financials.indemnityIncurred || 0,
        configData: new ChartConfig(),
      };
      this.indemnityDataSource.configData.showLabels = false;
      this.indemnityDataSource.configData.addSeries(
        'Paid',
        financials.indemnityPaid,
        paidColor,
      );
      this.indemnityDataSource.configData.addSeries(
        'Reserve',
        financials.indemnityReserve,
        reserveColor,
      );

      this.expenseDataSource = {
        firstPartyDeductible: financials.expenseDeductible || 0,
        totalIncurred: financials.expenseOtherIncurred || 0,
        configData: new ChartConfig(),
      };
      this.expenseDataSource.configData.showLabels = false;
      this.expenseDataSource.configData.addSeries(
        'Paid',
        financials.expenseOtherPaid,
        paidColor,
      );
      this.expenseDataSource.configData.addSeries(
        'Reserve',
        financials.expenseOtherReserve,
        reserveColor,
      );

      this.totalsDataSource = {
        firstPartyDeductible: financials.totalDeductible || 0,
        totalIncurred: financials.totalIncurred || 0,
        configData: new ChartConfig(),
      };
      this.totalsDataSource.configData.showLabels = false;
      this.totalsDataSource.configData.addSeries(
        'Paid',
        financials.totalPaid,
        paidColor,
      );
      this.totalsDataSource.configData.addSeries(
        'Reserve',
        financials.totalReserve,
        reserveColor,
      );
    }
  }

  private initFieldSecurity(): void {
    const restricted = this.session.user?.fieldSecurity?.restrictedFields || [];
    this.showCurrentAge = !restricted.includes('CurrentAge');
    this.showClaimantDateOfBirth = !restricted.includes('DateOfBirth');
    this.showAccountName = !restricted.includes('AccountName');
    this.showDateClaimReported = !restricted.includes('DateClaimReported');
    this.showDateClosed = !restricted.includes('DateClosed');
    this.showCauseOfLoss = !restricted.includes('CauseOfLoss');
    this.showNatureOfLoss = !restricted.includes('NatureOfLoss');
    this.showPartTarget = !restricted.includes('PartTarget');
  }

  captureFinancialChartImages(): string[] {
    return this.chartComponents
      .map((chart) => chart.captureDonutImage())
      .filter((image): image is string => image != null && image.length > 0);
  }
}
